export default __webpack_public_path__ + "static/media/desktop.dffbaf84.png";